import { createContext } from 'react';

const userModel = {
    displayName: 'Osito!',
    wordsPerPractice: 5,
    wordsForPractice: [],
}

export const UserContext = createContext(userModel);